import * as ChakraUI from '@chakra-ui/react';
import * as ChakraIcons from '@chakra-ui/icons';
import * as EmotionReact from '@emotion/react';
import EmotionStyledBase from '@emotion/styled';
import * as FramerMotion from 'framer-motion';

const EmotionStyled = Object.assign(EmotionStyledBase, {
  default: EmotionStyledBase
});

export { ChakraUI, ChakraIcons, EmotionReact, EmotionStyled, FramerMotion };
